import { modalsConstants } from '../utils/types';

export function openModal(modal, modalData) {
  return {
    type: modalsConstants.OPEN_MODAL,
    payload: {
      modal,
      modalData
    }
  };
}

export function resetModal() {
  return {
    type: modalsConstants.RESET
  };
}



// WEBPACK FOOTER //
// ./src/actions/modalsActions.js